module.exports = "<section class=\"app-footer\">\r\n  <div class=\"container-fluid\">\r\n    <span class=\"float-left\">\r\n      <span>Copyright © {{AppConfig.brand}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Version {{AppConfig.version}}</span>\r\n    </span>\r\n    <!-- <span class=\"float-right\">\r\n      <span>Built with Love <i class=\"material-icons\">favorite_border</i></span>\r\n    </span> -->\r\n  </div>\r\n</section>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/footer/footer.component.html
// module id = 1329
// module chunks = 25